import React from "react";
import DOMPurify from "dompurify";
import styles from "./CSS/ToastCenterBottom.module.css";
import { useUIContext } from "../context/UIContext";

export default function ToastCenterBottom() {
  const { toastCenterBottom } = useUIContext();

  if (!toastCenterBottom.visible) return null;

  const toastStyle = {
    backgroundColor: toastCenterBottom.color || "#198754", // 기본 색상 유지
  };

  return (
    <div
      className={styles.toastCenterBottom}
      style={toastStyle}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(toastCenterBottom.message),
      }}
    />
  );
}
